import { makeHook } from "../../utils/makeSingleArgHook";
import getSingleAccountGroupV4, { url, } from "../requests/getSingleAccountGroupV4";
export const singleAccountGroupV4KeyMaker = (accountGroupId) => [url(accountGroupId)];
const useGetAccountGroupsV4 = makeHook(getSingleAccountGroupV4, singleAccountGroupV4KeyMaker);
export default useGetAccountGroupsV4;
//# sourceMappingURL=useGetSingleAccountGroupV4.js.map